import React from 'react';

import { RoofPlaneGeometry } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { LayoutLinePickerField } from '../interface/subpanels/insertions/truss-envelope/LayoutLinePickerField';

export function RoofPlaneDefinitionField(props: {
  type: 'roof' | 'ceiling';
  value: RoofPlaneGeometry | undefined;
  disabled?: boolean;
}) {
  const value = (() => {
    switch (props.value?.type) {
      case null:
      case undefined:
        return '<none>';

      case 'Absolute':
        return '<absolute line>';

      case 'BearingEnvelope':
        return '<beam or wall>';

      default:
        assertExhaustiveSwitch(props.value);
    }
  })();

  return (
    <LayoutLinePickerField
      label="Definition"
      target={`${props.type}-plane-definition`}
      value={value}
      disabled={props.disabled}
    />
  );
}
